import Badge from './Badge';
export default Badge;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-badge/src/index.js